module.exports = __webpack_public_path__ + "static/media/American Express.85cc8a89.svg";